module.exports = __webpack_public_path__ + "img/icon-case-sensitive.698391e0.svg";